<template>
    <v-container class="grey lighten-5" fluid>
        <v-row align="center" justify="center">
            <v-col md="8" sm="8" xs="12">
                <v-card>
                   <v-card-title class="px-3">Board a new merchant</v-card-title>
                    <v-divider></v-divider>

                        <v-row class="px-4 py-4 pb-2">
                            <v-col md="6" sm="6" xs="6" class="pb-0">
                                <v-select
                                    :items="pspList"
                                    label="Select a gateway"
                                    @change="pspHandle"
                                    dense
                                ></v-select>
                            </v-col>
                            <v-col md="6" sm="6" xs="6" class="pb-0">
                                <v-select
                                    :disabled="!state"
                                    v-model="clearingInstitute"
                                    :items="clearingInstitutesList"
                                    label="Select a clearing institute"
                                    dense
                                ></v-select>
                            </v-col>
                        </v-row>

                        <secure-trading
                            v-if="clearingInstitute == 'Securetrading_Omnipay' || clearingInstitute == 'SecureTrading Omnipay Demo'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                        ></secure-trading>

                        <cashflows
                            v-if="clearingInstitute == 'Voice Commerce Group' || clearingInstitute == 'VCG Test'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                        ></cashflows>

                        <paysafe
                            v-if="clearingInstitute == 'Optimalpayment' || clearingInstitute == 'Optimalpayment Test'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                        ></paysafe>

                         <worldline
                            v-if="clearingInstitute == 'Worldline' || clearingInstitute == 'Worldline Test'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                        ></worldline>

                        <bspayone
                            v-if="clearingInstitute == 'BSCardServices' || clearingInstitute == 'B+S Card Service Test'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                        ></bspayone>

                         <concardis
                            v-if="clearingInstitute == 'Concardis' || clearingInstitute == 'Concardis Test'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                        ></concardis>

                        <first-data
                            v-if="clearingInstitute == 'FDMS_UK'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                        ></first-data>

                        <elavon
                            v-if="clearingInstitute == 'Elavon' || clearingInstitute == 'Elavon-euroconex_UK_Test'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                        ></elavon>

                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SecureTrading from '@/components/onboarder/acquirers/SecureTrading.vue';
import Cashflows from '@/components/onboarder/acquirers/Cashflows.vue';
import Paysafe from '@/components/onboarder/acquirers/Paysafe.vue';
import Worldline from '@/components/onboarder/acquirers/Worldline.vue';
import BSPayone from '@/components/onboarder/acquirers/BSPayone.vue';
import Concardis from '@/components/onboarder/acquirers/Concardis.vue';
import FirstData from '@/components/onboarder/acquirers/FirstData.vue';
import Elavon from '@/components/onboarder/acquirers/Elavon.vue';

export default {
    components: {
        'secure-trading': SecureTrading,
        'cashflows': Cashflows,
        'paysafe': Paysafe,
        'worldline': Worldline,
        'bspayone': BSPayone,
        'concardis': Concardis,
        'first-data': FirstData,
        'elavon': Elavon
    },

    data() {
        return {
            state: null,
            clearingInstitute: null,
            clearingInstitutesList: [],
            clearingInstitutesListLive: [{ value: 'Bambora (via Evry)', text: 'Bambora (via Evry)' },
                                         { value: 'BSCardServices', text: 'BS PAYONE' },
                                         { value: 'Voice Commerce Group', text: 'Cashflows' },
                                         { value: 'Concardis', text: 'Concardis' },
                                         { value: 'Elavon', text: 'Elavon' },
                                         { value: 'FDMS_UK', text: 'First Data' },
                                         { value: 'Optimalpayment', text: 'Paysafe' },
                                         { value: 'Securetrading_Omnipay', text: 'Secure Trading' },
                                         { value: 'Wirecard', text: 'Wirecard' },
                                         { value: 'Worldline', text: 'Worldline' }],

            clearingInstitutesListTest: [{ value: 'Bambora (via Evry)', text: 'Bambora (via Evry)' },
                                            { value: 'B+S Card Service Test', text: 'BS PAYONE' },
                                            { value: 'VCG Test', text: 'Cashflows' },
                                            { value: 'Concardis Test', text: 'Concardis' },
                                            { value: 'Elavon-euroconex_UK_Test', text: 'Elavon' },
                                            { value: 'Optimalpayment Test', text: 'Paysafe' },
                                            { value: 'SecureTrading Omnipay Demo', text: 'Secure Trading' },
                                            { value: 'Wirecard Test', text: 'Wirecard' },
                                            { value: 'Worldline Test', text: 'Worldline' }],

            pspList: [{ value: 'Live', text: 'Live' },
                      { value: 'Test', text: 'Test' }]
        }
    },
    methods: {
        pspHandle(value) {
            this.state = value;
            this.clearingInstitute = null;
            this.clearingInstitutesList = value == 'Live' ? this.clearingInstitutesListLive : this.clearingInstitutesListTest;
        }
    }
}
</script>

<style>

</style>